import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.scss";

export function ActionButtons(props) {
  const className = `${style.actionButtons} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ActionButtons.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * children elements given to action container
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

ActionButtons.defaultProps = {
  className: "",
};
